import React, { useEffect } from 'react';
import { getTransactionsData } from '../../services/pricing/PricingService';

const usePaddleTransactions = (setTransaction: React.Dispatch<any | null>): any => {
  useEffect(() => {
    getTransactionsData().then((transactionResponse: any) => {
      setTransaction(transactionResponse);
    });
  }, []);
};

export default usePaddleTransactions;
